import React, { Fragment } from "react";

const IndexPage = ({ lang }) => (
  <Fragment>
    <div className="container">
      <h2 align="center">
        <b>DeloitteDirect</b>
      </h2>
      <h3 align="center">
        <b>Datenschutzhinweis</b>
      </h3>
      <p align="right">Datum: 25.5.2018</p>
      <p>
        <br />
      </p>
      <p>
        <b>1. Gr&uuml;nde f&uuml;r den Datenschutzhinweis</b>
      </p>
      <p>
        Die Sicherheit Ihrer Daten ist uns wichtig. Wir m&ouml;chten Sie daher
        informieren, wie wir personenbezogene Daten im Rahmen der Services, die
        wir &uuml;ber das <b>Deloitte Direct Portal</b> (&ldquo;das
        Portal&rdquo;) zur Verf&uuml;gung stellen, erheben, nutzen und
        weitergeben.
      </p>
      <p>
        Dieser Datenschutzhinweis (auch &ldquo;<b>Hinweis</b>&rdquo;) beschreibt
        wie Deloitte Tax Wirtschaftspr&uuml;fungs GmbH (oder &quot;<b>wir</b>
        &quot;) Renngasse 1/ Freyung, Postfach 2, 1010 Wien, &Ouml;sterreich
        personenbezogene Daten verarbeiten, welche in Verbindung mit dem Portal
        erhoben werden (zug&auml;nglich &uuml;ber folgende Website:
        portal.deloitte.direct ; mehr Informationen auf: www.deloitte.at).
      </p>
      <p></p>
      <p>
        Wir danken Ihnen, dass Sie diesen Datenschutzhinweis sorgf&auml;ltig
        durchlesen. Durch die Portalnutzung haben Sie diese Datenschutzhinweise
        zu Kenntnis genommen. Sollten Sie Fragen betreffend Ihrer
        personenbezogenen Datenspeicherung haben, kontaktieren Sie uns bitte
        unter office@deloitte.at
      </p>
      <p></p>
      <p>
        <b>2. Erhebung personenbezogener Daten</b>
      </p>
      <p>
        Aufgrund unserer Leistungserbringung, im zwischen Ihnen und Deloitte
        vereinbarten Umfang (zum Beispiel laut Angebot), sind wir f&uuml;r einen
        verantwortungsvollen Umgang der personenbezogenen Daten verantwortlich.
        So m&ouml;chten wir Sie auf die Bedeutung der folgenden Begriffe
        hinweisen:
      </p>
      <p>
        <b>Personenbezogene Daten</b> sind jegliche Informationen die den
        Benutzer direkt identifizieren, z.B. Name, Adresse, Geburtsdatum, E-Mail
        Adresse, IP-Adresse, Telefonnummer, Familienstand, Gewinn- und
        Verlustrechnungen und Jahresabschl&uuml;sse. Sie beinhalten auch
        jegliche Informationen, die den Benutzer indirekt identifizieren oder
        die den Benutzer im Zusammenhang mit anderen Informationen potentiell
        identifizieren k&ouml;nnten. Zum Beispiel ist eine Kontonummer f&uuml;r
        sich betrachtet nicht personenbezogen; sie wird es aber wenn sie mit dem
        Namen des Kontoinhabers in Verbindung gebracht wird.
      </p>
      <p>
        Die Verarbeitung personenbezogener Daten bezieht sich auf alle
        Beratungsleistungen und &ndash; services im Zusammenhang mit
        personenbezogenen Daten. Dies beinhaltet die Erhebung, Aufzeichnung,
        Sammlung, Benutzung, Beratung, &Auml;nderung, Weitergabe, Verbreitung,
        Beschr&auml;nkung oder Vernichtung personenbezogener Daten.
      </p>
      <p></p>
      <p>
        <b>3. Welche Daten verarbeiten wir</b>
      </p>
      <p>
        Wir verpflichten uns dazu nur jene personenbezogenen Daten zu erheben,
        welche zur Auftragsdurchf&uuml;hrung n&ouml;tig sind und dort, wo Sie
        als Portalbenutzer Anwendungen f&uuml;r die Zusammenarbeit mit uns bzw.
        f&uuml;r Ihren eigenen Betrieb nutzen. Zum Beispiel erm&ouml;glichen
        Anwendungen, wie das Fakturierungsprogramm Invoicing, die Erfassung von
        Kundenstammdaten f&uuml;r Ihr Unternehmen. Wir als Deloitte verarbeiten
        nur jene Daten, die f&uuml;r die jeweilige, durch Sie beauftragte
        Leistung n&ouml;tig und relevant sind.
      </p>
      <p>
        Je nach Anwendung des Portals bzw. dessen betrieblicher Nutzung werden
        verschiedene Daten verarbeitet. Typischerweise betrifft dies ein oder
        mehrere personenbezogenen Daten:
      </p>
      <ul>
        <li>
          <p>
            Berufsbezogene Kontaktdaten, wie Titel und Funktion, berufliche
            Telefonnummer und E-Mail Adresse.
          </p>
        </li>
        <li>
          <p>
            Personenbezogene Daten, wie insbesondere Vor- und Zuname,
            Geburtsdatum, pers&ouml;nliche E-Mail Adresse und Telefonnummer,
            Privatadresse.
          </p>
        </li>
        <li>
          <p>
            Daten in Bezug auf den Personalbereich bzw. die Personalverrechnung,
            wie zum Beispiel Berufsbezeichnung, Dienstalter und Einstufung,
            Kostenstellenzuordnung, Details zu Entlohnung, Sachleistungen,
            Arbeitszeit (Abwesenheit, Urlaub, etc.), Gruppenversicherung und
            Pensionsdetails, Informationen zur Familienstatus etc.
          </p>
        </li>
        <li>
          <p>
            Finanzdaten einschlie&szlig;lich Kontoausz&uuml;ge, Kredit- oder
            Debitkartennummern, Einnahmen, Ersparnisse, Investitionen,
            Investitionsausgaben, erl&ouml;sbezogene Bewertungen, Beihilfen und
            Zusch&uuml;sse, Finanztransaktionen.
          </p>
        </li>
        <li>
          <p>
            Informationen bez&uuml;glich Gesch&auml;ftsvereinbarungen, Art und
            Umfang beruflicher T&auml;tigkeiten, Details bez&uuml;glich
            Gesch&auml;ftsf&uuml;hrung, Vertr&auml;ge, Lizenzen etc.
          </p>
        </li>
        <li>
          <p>
            IP-Adressen oder andere Ger&auml;teerkennungen, Metadaten der
            elektronischen Kommunikation (Zeit und Dauer der Verbindung mit dem
            Portal), Anmeldeinformationen (Benutzername, Passw&ouml;rter).
          </p>
        </li>
        <li>
          <p>
            Details bez&uuml;glich Anfragen, Ersuchen und Beschwerden, welche
            &uuml;ber das Portal eingebracht wurden.
          </p>
        </li>
      </ul>
      <p>
        Die oben angef&uuml;hrten Daten betreffen im Wesentlichen Sie als
        berechtigten Nutzer des Portals sowie Ihre Mitarbeiter bzw. andere
        Beg&uuml;nstigte (z.B. Familienmitglieder), ihre Klienten, Zulieferer
        und Gesch&auml;ftspartner.
      </p>
      <p></p>
      <p>
        <b>4. Zwecke der Datenverarbeitung</b>
      </p>
      <p>
        Grunds&auml;tzlich gilt, dass wir personenbezogene Daten nur f&uuml;r
        bestimmte - in unserem Vertrag [ersichtlich unter Dokumenten Manager
        &rarr; Vereinbarungen Deloitte &rarr; Vollmacht und AAB&rsquo;s] mit
        Ihnen definierte Zwecke und entsprechend Ihrer Weisung verarbeiten.
        M&ouml;glicherweise verwenden wir personenbezogene Daten auch f&uuml;r
        rechtm&auml;&szlig;ige Gesch&auml;ftszwecke wie z.B. um die Sicherheit
        Ihrer Transaktionen &uuml;ber das Portal zu gew&auml;hrleisten. Wir
        nutzen personenbezogene Daten, die &uuml;ber das Portal zur
        Verf&uuml;gung stehen, f&uuml;r keine anderen Zwecke. Das bedeutet, die
        Datenverarbeitung steht im Zusammenhang mit unseren Services,
        Anwendungen und Leistungen, welche wir f&uuml;r Sie anbieten, oder mit
        Ihren Anfragen in Verbindung stehen, oder zum Beispiel in angemessener
        Weise von uns als Auftragsverarbeiter erwarten werden k&ouml;nnen.
      </p>
      <p>
        Daher verarbeiten wir personenbezogene Daten im Portal f&uuml;r folgende
        Zwecke:
      </p>
      <ul>
        <li>
          <p>
            <b>Kundenverwaltung</b>: Um Ihnen Zugang zum Portal gew&auml;hren zu
            k&ouml;nnen, m&uuml;ssen wir z.B. Informationen bez&uuml;glich Ihrer
            Identit&auml;t, Ihres Berufs oder Ihres Unternehmensstatus (zB
            Gesellschaftsform, Branche etc.) verarbeiten. Dies ist n&ouml;tig um
            den geforderten, Deloitte internen Konflikt- und
            Unabh&auml;ngigkeitscheck durchzuf&uuml;hren und
            abzuschlie&szlig;en. Desweiteren speichern wir diese Informationen
            in Bezug auf Ihre Portal-Registrierung und bewahren diese sicher
            auf.
          </p>
        </li>
        <li>
          <p>
            <b>Erbringung von Dienstleistungen</b>: Abh&auml;ngig von den
            Anwendungen und Leistungen, f&uuml;r welche Sie sich auf dem Portal
            entschieden haben, m&uuml;ssen wir Informationen, welche
            personenbezogene Daten beinhalten k&ouml;nnen, erfassen, zentral
            speichern bzw. &uuml;bermitteln k&ouml;nnen. Leistungen, welche
            &uuml;ber das Portal angeboten werden, betreffen z.B. die Erstellung
            von Reports und Finanzanalysen, ein Dokumentenablagesystem und
            &ndash;archivierung, das Scannen von Dokumenten, die Verwaltung von
            Buchungseintr&auml;gen/ Buchungszeilen in der Buchhaltung und
            Berichte/ Ablagen f&uuml;r die Personalverrechnung (diese Unterlagen
            dienen der weiteren Verarbeitung in ausgew&auml;hlten Buchhaltungs-
            oder Lohnverrechnungssoftwareprogrammen), Prozessunterst&uuml;tzung
            bei der Erstellung von Angeboten bis hin zu Rechnungen, Support und
            allgemeine Office-Unterst&uuml;tzung in Bezug auf das
            Dokumentenmanagement und Berichtswesen. Eine Beschreibung der
            Anwendungen finden Sie auf{" "}
            <a href="http://www.deloitte.at/easy">www.deloitte.at</a>
          </p>
        </li>
        <li>
          <p>
            <b>Gew&auml;hrung von Zugriff auf Anwendungen</b>: Beispielsweise
            m&uuml;ssen wir die Zugangsdaten f&uuml;r die Personen, die in Ihrem
            Namen Zugang zum Portal erhalten, erfassen und verarbeiten, so dass
            sie Zugriff auf die von Ihnen gew&uuml;nschten Anwendungen haben.
            Dies gilt auch dann, wenn Sie als Kundenadministrator diese
            Berechtigungen f&uuml;r Ihre Mitarbeiter selbst verwalten.
          </p>
        </li>
        <li>
          <p>
            <b>Back-Office Portalverwaltung</b>: im Falle von umfangreicheren
            Portalanalysen und technischen Tests m&uuml;ssen wir gegebenenfalls
            personenbezogene Daten technisch verarbeiten. Dies k&ouml;nnte im
            Zuge der Einf&uuml;hrung von technischen Erweiterungen vorkommen
            oder umfangreichen Releasewechseln. sowie im Zuge der Wartung von
            Software, Fehlerbehebungen oder Qualit&auml;tskontrollen. Dies wird
            nur in dem Ausma&szlig; get&auml;tigt der f&uuml;r die
            Sicherstellung einer reibungslosen Funktionsweise des Portals bzw.
            im Zuge der Pr&uuml;fung von neuen Funktionalit&auml;ten an Portal
            notwendig ist.
          </p>
        </li>
        <li>
          <p>
            <b>Optimierung der Nutzung des Portals</b>: Um den
            Informationsaustausch mit Ihnen zu verbessern und rechtzeitig auf
            Ihre, &uuml;ber das Portal zugestellten Nachrichten reagieren zu
            k&ouml;nnen, erh&auml;lt eine eingeschr&auml;nkte Anzahl von
            Deloitte Mitarbeitern, das Deloitte Direct Projektteam, einen
            detaillierteren &Uuml;berblick zu den von Ihnen und Ihrem Deloitte
            Beratungsteam dokumentierten Informationen. Dieses Deloitte Direct
            Projektteam besteht aus Mitarbeitern der Deloitte Services
            Wirtschaftspr&uuml;fungs GmbH. Diese haben speziell f&uuml;r diesen
            Zweck (der Benutzerfreundlichkeit, des Helpdesks, des
            Benutzersupports etc.) autorisierte Zug&auml;nge &uuml;ber eine
            spezielle Anwendung am Portal.
          </p>
        </li>
        <li>
          <p>
            <b>
              Kontaktmanagement (Customer-Relationship-Management, kurz CRM)
            </b>{" "}
            : M&ouml;glicherweise verwenden wir die ins Portal eingespeisten
            Daten mit der Absicht Ihr Nutzerverhalten bzw. Ihren
            Informationsbedarf besser zu erkennen. Unser Ziel ist dabei ist, mit
            Ihnen besser Kontakt aufzunehmen oder Ihnen hochwertige auf Sie
            abgestimmte, digitale Services anbieten zu k&ouml;nnen. Um mit
            gr&ouml;&szlig;ter Sicherheit und hoher Schnelligkeit auf Ihre
            Anfragen und Bed&uuml;rfnisse reagieren zu k&ouml;nnen,
            zentralisieren wir alle Daten an einer einzigen Stelle des Portals.
            So ist es zuk&uuml;nftig m&ouml;glich, dass das Portal Erinnerungen
            oder Warnungen in Echtzeit zuschickt, wenn sich wesentliche
            Kennzahlen oder Analysen ver&auml;ndern bzw. &uuml;berpr&uuml;ft
            &Auml;nderungen hinsichtlich Anmelde- bzw. Kontaktinformationen. Wir
            verwenden diesen zentralen Speicherort auch um unsere Kommunikation
            und unsere Marketingkampagnen in Bezug auf unsere Deloitte
            Kundengruppen zu verbessern. Zum Beispiel, indem wir Ihnen f&uuml;r
            Ihr Gesch&auml;ftsfeld bzw. Ihre Branche relevante unternehmerische
            Mitteilungen zusenden. In diesen F&auml;llen verpflichtet sich
            Deloitte Tax Wirtschaftspr&uuml;fungs GmbH s&auml;mtliche
            Anforderungen des geltenden Rechtsbereichs zu erf&uuml;llen, falls
            erforderlich einschlie&szlig;lich der Einholung Ihrer Zustimmung,
            bevor tiefergehende Analysen gesetzt werden.
          </p>
        </li>
        <li>
          <p>
            <b>Datenschutz:</b>
            Es ist unsere Pflicht und unser gesetzm&auml;&szlig;iges Interesse
            sicherzustellen, dass Ihre Daten auf dem Portal gegen unbefugte oder
            unbeabsichtigte Zugriffe, Sch&auml;den oder sonstige
            unsachgem&auml;&szlig;e Verwendung gesch&uuml;tzt sind. Aus diesem
            Grund m&uuml;ssen wir m&ouml;glicherweise Logdateien, IP-Adressen,
            Positionsbestimmungsdaten oder andere Metadaten verarbeiten, wenn
            dies n&ouml;tig ist um unser Betriebsverm&ouml;gen oder die
            Vertraulichkeit Ihrer Daten zu sch&uuml;tzen, oder um auf
            sicherheitsrelevante Ereignisse reagieren zu k&ouml;nnen.
          </p>
        </li>
        <li>
          <p>
            <b>Anonymisierte Nutzeranalyse und Branchen-Benchmarking:</b> Um die
            Benutzerfreundlichkeit des Portals und den Gebrauch desselben zu
            messen und f&uuml;r zuk&uuml;nftige Verbesserungen zu nutzen, werden
            Ihre Daten m&ouml;glicherweise auch von Mitgliedsunternehmen des
            Deloitte Netzwerks genutzt. Datenanalysen k&ouml;nnen zudem zur
            Abstimmung von Kundentrends sowie f&uuml;r Benchmarking nach
            Branchen, Wirtschaftssektoren, Standorten oder anderen Parametern
            genutzt werden. Beachten Sie, dass in diesem Fall, in
            &Uuml;bereinstimmung mit geltendem Recht, lediglich Aggregat-
            und/oder anonymisierte Daten verarbeitet werden.
          </p>
        </li>
      </ul>
      <p></p>
      <p>
        <b>5. Weitergabe personenbezogener Daten</b>
      </p>
      <p>
        Um Ihnen den kompletten Umfang der &uuml;ber das Portal angebotenen
        Leistungen bieten zu k&ouml;nnen, ist es unumg&auml;nglich auf
        Drittanbieter aus den Bereichen IT-Infrastruktur, Software-Tools und
        anderen IT-Service Komponenten und Anwendungen zur&uuml;ckzugreifen. In
        all diesen F&auml;llen weisen wir unsere Drittanbieter (und
        gleicherma&szlig;en deren m&ouml;gliche Subunternehmer) mittels eines
        schriftlichen Vertrags ausdr&uuml;cklich darauf hin, dass
        personenbezogene Daten nur f&uuml;r die in der
        Dienstleistungsvereinbarung definierten F&auml;lle verwendet werden
        d&uuml;rfen. Wir haben strenge Vorschriften in Bezug auf
        Datenvertraulichkeit, -sicherheit und &ndash;zugangsverwaltung gesetzt
        und haben eine stark eingeschr&auml;nkte Datennutzung vorgesehen bzw.
        die R&uuml;ckgabe oder L&ouml;schung von Daten definiert, in
        &Uuml;bereinstimmung mit der geltenden Rechtslage und dem mit Ihnen
        abgeschlossen Vertrag.
      </p>
      <p>
        Die Art der Leistungen, f&uuml;r welche wir europ&auml;ische
        Drittanbieter (&ldquo;Subunternehmer&rdquo;) beauftragen, sind wie folgt
        :
      </p>
      <p>
        Betrieb des Portals; Entwicklung, Wartung und Bereitstellung des Portals
        in unserem Unternehmen.
      </p>
      <p>
        Fehlerbehebungen, zur Verf&uuml;gung stellen von Support inklusive der
        Erstellung von Qualit&auml;tsberichten in Zusammenhang mit dem Portal.
      </p>
      <p>Hosting von Anwendungen und Daten (Datenspeicherung);</p>
      <p>Monitoring und Verwaltung der IT-Infrastruktur (Server des Portals)</p>
      <p>
        Entwicklung und Wartung von Software je nach den Leistungen f&uuml;r die
        Sie sich entscheiden (z.B. kooperieren wir mit Softwareanbietern von
        Buchhaltungssystemen)
      </p>
      <p>
        Anbietern von Anwendungen oder Entwickler f&uuml;r die
        Verbindung/Interaktion mit dem Portal, Hinzuf&uuml;gen oder
        Erg&auml;nzen der Funktionen des Portals.
      </p>
      <p></p>
      <p>
        Sollten Sie weitere Fragen haben, mehr Informationen oder eine
        Auflistung der Anbieter ben&ouml;tigen, welche mit uns im Zusammenhang
        mit dem Portal zusammenarbeiten, so kontaktieren Sie uns bitte unter
        <a href="mailto:office@deloitte.at">
          <font face="Verdana, serif">
            <font size="2" style={{ fontSize: "10pt" }}>
              office@deloitte.at
            </font>
          </font>
        </a>
      </p>
      <p>
        Wenn wir mit Subunternehmern au&szlig;erhalb von &Ouml;sterreich
        arbeiten, treffen wir entsprechende Ma&szlig;nahmen um sicherzugehen,
        dass personenbezogene Daten im Empf&auml;ngerland entsprechend
        gesch&uuml;tzt werden. Zudem stellen wir sicher, dass personenbezogene
        Daten in keine L&auml;nder &uuml;bermittelt werden, die nicht Mitglied
        des Europ&auml;ischen Wirtschaftsraums (EWR) sind.
      </p>
      <p>
        Bitte beachten Sie, dass die Subunternehmer, welche uns in Verbindung
        mit dem Portal unterst&uuml;tzen, dieselben Verpflichtungen treffen wie
        in diesem Hinweis beschrieben.
      </p>
      <p></p>
      <p>
        <b>6. Aus&uuml;bung Ihrer Rechte</b>
      </p>
      <p>
        Als Anbieter von Dienstleistungen sind wir bem&uuml;ht, Ihnen bei der
        Beantwortung von Anfragen in Bezug auf Ihre Rechte so rasch wie
        m&ouml;glich behilflich zu sein. Dies betrifft insbesondere die
        Datenverarbeitung am Portal, welche Personen (Mitarbeitern, Partnern,
        Vertretern, Kunden, etc.) Ihres Unternehmens betreffen. Dazu
        ben&ouml;tigen Sie m&ouml;glicherweise unsere Unterst&uuml;tzung um:
      </p>
      <ul>
        <li>
          <p>
            zu best&auml;tigen, ob wir personenbezogene Daten, f&uuml;r welche
            Sie als Datenverantwortlicher verantwortlich sind, verarbeiten. In
            diesem Fall erhalten Sie von uns Unterst&uuml;tzung mittels der
            Zusendung einer Kopie der angeforderten personenbezogenen Daten.
          </p>
        </li>
        <li>
          <p>
            zu best&auml;tigen, ob wir personenbezogene Daten verarbeiten,
            &uuml;ber welche Sie als Verantwortlicher verf&uuml;gen. In diesem
            Fall erhalten Sie von uns Unterst&uuml;tzung in Bezug auf die
            angeforderten personenbezogenen Daten bzw. sind wir Ihnen behilflich
            ein Kopie der angeforderten personenbezogenen Daten zu erhalten;
          </p>
        </li>
        <li>
          <p>
            falsche, personenbezogene Daten &uuml;ber das Portal zu berichtigen,
            zu aktualisieren oder um unvollst&auml;ndige, personenbezogene Daten
            zu vervollst&auml;ndigen;
          </p>
        </li>
        <li>
          <p>
            personenbezogene Daten zu l&ouml;schen/ bei L&ouml;schungsanfragen;
          </p>
        </li>
        <li>
          <p>
            die Verarbeitung personenbezogener Daten durch uns
            einzuschr&auml;nken; und
          </p>
        </li>
        <li>
          <p>
            zur &Uuml;bermittlung personenbezogener Daten an Sie oder f&uuml;r
            die &Uuml;bermittlung personenbezogener Daten an einen anderen
            Datenverantwortlichen in Ihrem Auftrag (Portabilit&auml;t/
            &Uuml;bertragbarkeit);
          </p>
        </li>
      </ul>
      <p>
        Gleichzeitig werden wir Anfragen bez&uuml;glich der Aus&uuml;bung der
        oben genannten Rechte gerne beantworten; zu den Sie betreffenden
        personenbezogenen Daten, welche wir &uuml;ber das Portal und die damit
        in Zusammenhang stehenden Anwendungen sammeln, verarbeiten und
        speichern.
      </p>
      <p></p>
      <p>
        Sie k&ouml;nnen au&szlig;erdem Einw&auml;nde in Bezug auf den Gebrauch
        mancher, Ihrer personenbezogenen Daten zu den hier beschriebenen Zwecken
        geltend machen (siehe Zwecke der Datenverarbeitung), wenn Sie aus
        legitimen, pers&ouml;nlichen Gr&uuml;nden den Gebrauch dieser Daten
        nicht w&uuml;nschen. Wenn wir diese Daten trotz Ihres Einwandes nicht
        aufgrund anderer Gr&uuml;nde ben&ouml;tigen (z.B. rechtlicher Anspruch
        oder eine Vertragspflicht), werden wir die Verarbeitung stoppen. Bitte
        beachten Sie jedoch, dass wir Ihnen m&ouml;glicherweise nicht den vollen
        Zugang zum Portal und zu allen von Ihnen gew&uuml;nschten Funktionen
        bieten k&ouml;nnen, wenn Sie die Verarbeitung bestimmter Daten &uuml;ber
        das Portal nicht w&uuml;nschen.
      </p>
      <p></p>
      <p>
        Jegliche Anfragen bez&uuml;glich der Rechte des Datensubjekts (siehe
        oben) k&ouml;nnen uns &uuml;ber{" "}
        <a href="mailto:office@deloitte.at">
          <font face="Verdana, serif">
            <font size="2" style={{ fontSize: "10pt" }}>
              office@deloitte.at
            </font>
          </font>
        </a>
        <font color="#000000">
          <font face="Verdana, serif">
            <font size="2" style={{ fontSize: "10pt" }}></font>
          </font>
        </font>
        mitgeteilt werden.
      </p>
      <p></p>
      <p>
        <b>7. Speichern personenbezogener Daten</b>
      </p>
      <p>
        Wir verpflichten uns dazu Ihre Daten fehlerfrei und aktuell zu halten.
        Wir haben nicht die Absicht diese &uuml;ber die Nutzungsdauer der von
        Ihnen &uuml;ber das Portal abonnierten Leistungen hinaus zu speichern.
      </p>
      <p>
        Wie lange wir Ihre Daten ben&ouml;tigen, h&auml;ngt vom Zweck ab,
        f&uuml;r welchen wir diese verwahren m&uuml;ssen, aber auch von
        individuellen Anforderungen, die aus dem mit Ihnen abgeschlossenen
        Vertrag resultieren. Daher gibt es keinen allgemeinen
        Aufbewahrungszeitraum, der f&uuml;r alle Datentypen, der auf dem Portal
        gespeicherten personenbezogenen Informationen, g&uuml;ltig ist.
      </p>
      <p>
        Wir achten au&szlig;erdem auf weitere Gr&uuml;nde, die aus unserer
        Verpflichtung entstehen personenbezogene Daten eventuell l&auml;nger
        aufzubewahren als die reine Portalnutzung. Beispielsweise gibt es
        Verpflichtungen, Daten als gesetzliche Beweismittel f&uuml;r
        Gerichtsverfahren aufzubewahren oder die Datenaufbewahrungspflicht
        aufgrund l&auml;nderspezifischer bzw. rechtlicher Gesetze (Audit,
        Steuer, Finanzverwaltung etc.) vorsehen.
      </p>
      <p>
        Als allgemeine Regel und soweit keine Ausnahme (siehe oben) zutrifft,
        verpflichten wir uns personenbezogene Daten zu l&ouml;schen, zu
        retournieren oder alle Kopien davon sp&auml;testens 12 Monate nach
        Vertragsbeendigung zu l&ouml;schen, au&szlig;er es liegen Ausnahmen vor,
        welche erfordern w&uuml;rden, dass wir Ihre Daten f&uuml;r einen
        l&auml;ngeren Zeitraum speichern m&uuml;ssen.
      </p>
      <p>
        Sollten Sie mehr Informationen in Bezug auf Ort und Dauer der
        Speicherung Ihrer personenbezogenen Daten, oder das Recht diese
        l&ouml;schen zu lassen haben, so kontaktieren Sie uns bitte unter{" "}
        <a href="mailto:office@deloitte.at">
          <font face="Verdana, serif">
            <font size="2" style={{ fontSize: "10pt" }}>
              office@deloitte.at
            </font>
          </font>
        </a>
      </p>
      <p></p>
      <p>
        <b>8. Schutz personenbezogener Daten</b>
      </p>
      <p>
        Nach geltendem Recht ergreifen wir geeignete technische und
        organisatorische Ma&szlig;nahmen, um sicherzustellen, dass
        personenbezogene Daten in Bezug auf die hier genannten Vorg&auml;nge
        ordnungsgem&auml;&szlig; vor unbeabsichtigter oder unberechtigter
        Weitergabe sowie Zugriff, Vernichtung und jegliche andere Form der
        unrechtm&auml;&szlig;igen Verarbeitung gesch&uuml;tzt werden.
      </p>
      <p>
        Zu diesen Ma&szlig;nahmen geh&ouml;ren: Datenzugriffsverwaltung;
        verschl&uuml;sselte Daten&uuml;bertragung (z.B. https/SSL/TLS 1.2
        Standards) &uuml;ber das Netzwerk; regelm&auml;&szlig;ige
        Penetrationstests und Cyber-Risk Pr&uuml;fungen des Portals; Logging,
        verschl&uuml;sselte Archivierung, Back-ups und andere Ma&szlig;nahmen
        entsprechend den Best Practices in der Branche sowie weithin anerkannter
        Zertifizierungsprogramme (z.B. ISO 27001).
      </p>
      <p></p>
      <p>
        <b>9. Fragen, Bedenken und Beschwerden</b>
      </p>
      <p>
        Sollten Sie Fragen oder Bedenken haben wie die Deloitte Tax
        Wirtschaftspr&uuml;fungs GmbH personenbezogene Daten in Verbindung mit
        dem Portal verarbeitet, so kontaktieren Sie bitte{" "}
        <a href="mailto:office@deloitte.at">
          <font face="Verdana, serif">
            <font size="2" style={{ fontSize: "10pt" }}>
              office@deloitte.at
            </font>
          </font>
        </a>
      </p>
      <p></p>
      <p>
        Sie haben au&szlig;erdem das Recht eine Beschwerde bei der
        zust&auml;ndigen Aufsichtsbeh&ouml;rde einzubringen (insbesondere im
        Mitgliedsstaat in dem Sie Ihren gew&ouml;hnlichen Aufenthalt haben, in
        dem sich Ihr Arbeitsplatz oder der Ort des angeblichen Versto&szlig;es
        befindet).
      </p>
      <p></p>
      <p>
        <b>10. Aktualisierungen dieses Datenschutzhinweises</b>
      </p>
      <p>
        Die letzte &Auml;nderung dieses Datenschutzhinweises ist am Datum auf
        der ersten Seite ersichtlich.
      </p>
      <p>
        Um diesen Datenschutzhinweis herunterzuladen klicken Sie bitte auf{" "}
        <a
          href={`DeloitteDirect.Privacy.Statement_${lang}.pdf`}
          title="DeloitteDirect.Privacy.Statement"
        >
          Deloitte Direct privacy statement
        </a>
        .
      </p>
    </div>
  </Fragment>
);

export default IndexPage;
